import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
// Import Fonts (Self-hosted)
import '@fontsource/outfit/300.css';
import '@fontsource/outfit/400.css';
import '@fontsource/outfit/500.css';
import '@fontsource/outfit/600.css';
import '@fontsource/outfit/700.css';

import './index.css' // Import global styles (including Tailwind/custom CSS)
import App from './App.tsx'

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <App />
  </StrictMode>,
)
